// api.js
export async function getJSON(url) {
    const res = await fetch(url, { credentials: "include" }); // 세션/쿠키 사용 시
    if (!res.ok) {
        let msg = "";
        try { msg = await res.text(); } catch { }
        throw new Error(msg || `HTTP ${res.status}`);
    }
    return await res.json();
}

export async function postJSON(url, body) {
    const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(body),
    });

    if (!res.ok) {
        let data = await res.json()
        throw new Error(data?.message);
    }
    return await res.json();
}

export async function patchJSON(url, body) {
    const res = await fetch(url, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
}
